<div class="wt-info-note" [class.wt-info-note--opened]="isOpen" [class.wt-info-note--invert]="invert">
  <div class="wt-info-note__icon" (click)="toggle()"></div>
</div>
